import { useLang } from "../context/LanguageContext";

export function WhyNumbered() {
  const { t } = useLang();

  return (
    <section className="py-20 bg-white" data-testid="why-numbered">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <div className="inline-block text-[10px] tracking-[0.3em] text-[#ef4444] font-semibold mb-3 uppercase">
            {t.whyNumbered.eyebrow}
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#0891b2] mb-4 leading-tight">
            {t.whyNumbered.title}
          </h2>
          <p className="text-slate-600 leading-relaxed">{t.whyNumbered.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-8 gap-y-10 relative">
          {t.whyNumbered.items.map((item, i) => (
            <div key={i} className="relative pt-4" data-testid={`why-num-${i}`}>
              <div className="absolute -top-2 start-0 font-display text-[70px] leading-none text-[#0891b2]/8 select-none pointer-events-none" style={{ color: 'rgba(30, 58, 138, 0.08)' }}>
                {String(i + 1).padStart(2, "0")}
              </div>
              <div className="relative">
                <div className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-[#ef4444] text-white font-display text-sm mb-3">
                  {i + 1}
                </div>
                <h3 className="font-display text-lg text-[#0891b2] mb-2 leading-snug">{item.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed">{item.text}</p>
              </div>
            </div>
          ))}
        </div>

        {/* By the numbers */}
        <div className="mt-16 pt-10 border-t border-slate-200">
          <div className="text-center mb-6">
            <div className="inline-block text-[10px] tracking-[0.3em] text-slate-500 font-semibold uppercase">
              {t.whyNumbered.numbersTitle}
            </div>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
            {t.whyNumbered.numbers.map((n, i) => (
              <div key={i} className="text-center" data-testid={`bynumbers-${i}`}>
                <div className="font-display text-4xl lg:text-5xl text-[#0891b2] mb-1">{n.value}</div>
                <div className="text-xs uppercase tracking-widest text-slate-500">{n.label}</div>
              </div>
            ))}
          </div>
          <p className="text-center text-slate-500 text-sm mt-8 max-w-2xl mx-auto">{t.whyNumbered.tagline}</p>
        </div>
      </div>
    </section>
  );
}
